export const DataFileAddInitialValues = {
  user_id: null,
  data_sharing_request_id: null,
};

export const Units = ['Bytes', 'KB', 'MB', 'GB'];
